import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import uniqid from 'uniqid';
import Router from './routers/Router';
import reducers from './reducers';

// Create raw data for master devices, auth token, and search bar option in redux store.
let uniquePath = uniqid();

const store = configureStore({
  reducer: reducers,
  preloadedState: {
    auth: {
      authenticated: localStorage.getItem('token'),
      searchBarShow: false,
      searchBarStyle: 'animated animated-duration-custom slideInDown pb-3',
      deviceDriverError: {
        ['root/0']: true,
        [`root/0/${uniquePath}/0`]: true 
      }, 
      deviceApi: [
        {
          paramField: '',
          paramUniqueKey: uniquePath,
          paramValues: [
            {
              paramField: '',
              paramUniqueKey: uniqid(),
              paramValues: [],
              path: `root/0/${uniquePath}/0`,
              type: 'root'
            },
          ],
          path: 'root/0',
          type: 'root'
        },
      ]
    }
  }
  ,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router />
  </Provider>
);

